module.exports = __webpack_public_path__ + "static/media/membership-number.a55cfb38.png";